import * as yup from 'yup';

export const validationSchema = yup.object({
    pumpNumber: yup.string().required("Required"),
    inventoryId: yup.string().required("Required")
})